/**
 * @owner @Appboy/ingestion
 */

export const appsTransformationsCacheKey = "/apps/transformations" as const;

export const appsTransformationsTransformationId = "/apps/transformations/:transformation_id";

export const appsTransformationsTransformationIdSubmit = "/apps/transformations/:transformation_id/submit";

export const appsTransformationsPackageDetailCacheKey = "/apps/transformations_package_detail";
export const appsTransformationsTransformationRename = "/apps/transformations/:transformation_id/rename";
